function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".oneA,.oneB{fill:none;stroke:#5352ed;stroke-linejoin:round;stroke-width:2px;}.oneA{stroke-linecap:round;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-984.5 -238.5)"
}, /*#__PURE__*/React.createElement("path", {
  className: "oneA",
  d: "M997.941,267.329a13.956,13.956,0,1,1,15.4-15.306",
  transform: "translate(0)"
}), /*#__PURE__*/React.createElement("path", {
  className: "oneA",
  d: "M994.663,259.116a8.081,8.081,0,1,1,10.434-10.5",
  transform: "translate(1.876 1.876)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(997.399 251.233)"
}, /*#__PURE__*/React.createElement("path", {
  className: "oneB",
  d: "M1007.984,256.857l4.1-4.1L993.6,247.487l5.266,18.487,3.895-3.893,7.471,7.471,5.223-5.224Z",
  transform: "translate(-993.601 -247.487)"
})));

function SvgOneClick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.754,
    height: 35.798,
    viewBox: "0 0 35.754 35.798",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneClick);
export default __webpack_public_path__ + "static/media/OneClick.dae1dbb9.svg";
export { ForwardRef as ReactComponent };